<div class="staticPage">
    <h1 class="blueColor">{{ 'contact' | translate }}</h1>
    <div class="gradientDivider"></div>

    <div class="contactContainer">
      <div class="content-from-editor" [innerHTML]="contactHtml.content"></div>
      <div class="contact-form">
        <h2>{{'contact_form_title' | translate}}</h2>
        <form [formGroup]="contactForm" (submit)="submitForm()">
          <span class="ui-float-label">
            <input type="text" formControlName="name" pInputText style="width:100%" >
            <label for="float-input">{{'contact_name' | translate}}</label>
          </span>

          <div style="height:20px;"></div>

          <span class="ui-float-label">
            <input type="email" formControlName="email" pInputText style="width:100%">
            <label for="float-input">{{'contact_email' | translate}}</label>
          </span>

          <div style="height:20px;"></div>

          <span class="ui-float-label">
            <textarea rows="5" [style]="{'width':'100%'}" pInputTextarea formControlName="text"></textarea>
            <label for="float-input">{{'contact_text' | translate}}</label>
          </span>

          <div style="height:20px;"></div>

          <div class="ui-sm-6 ui-md-5 ui-lg-3 ui-xl-2" style="padding-left: 0;">
            <button *ngIf="!loading" pButton type="submit" label="{{'contact_send' | translate}}" [disabled]="contactForm.invalid" class="ui-button-info" style="width: 100%;"></button>
            <app-loader *ngIf="loading"></app-loader>
          </div>
        </form>
      </div>
    </div>

  </div>
